// Auth payloads shared between server and SPA.
/** Group role ladder. Carried over unchanged from the PHP implementation. */
export const GroupRole = {
    MEMBER: 1,
    MODERATOR: 10,
    EVENTS_MANAGER: 50,
    ADMIN: 100,
    OWNER: 999,
};
/**
 * site_user_account.site_role.
 *
 * ⚠ 100 grants NOTHING inside a group as of 2026-08-21. It used to short-circuit
 * every group-role check; a site admin now needs a `group_members` row like anyone
 * else, and reaches a group they do not belong to only by masquerading.
 */
export const SiteRole = {
    USER: 1,
    ADMIN: 100,
};
export const HOME_MODES = ['panel', 'feed'];
/** The default for every existing account: what home already does today. */
export const DEFAULT_HOME_MODE = 'panel';
export function isHomeMode(value) {
    return HOME_MODES.includes(value);
}
/** Tolerates a NULL or unrecognised column rather than throwing on a read. */
export function normalizeHomeMode(value) {
    return value && isHomeMode(value) ? value : DEFAULT_HOME_MODE;
}
// --- Account deletion ------------------------------------------------------
//
// App Store Review Guideline 5.1.1(v): an app that lets a user create an account
// must let them initiate deletion from inside the app. See docs/plan-ios-ship.md
// item 1 for the whole design, including why this is a SOFT delete.
/** The phrase the client must send, and the user must type, to delete. */
export const DELETE_ACCOUNT_PHRASE = 'DELETE';
//# sourceMappingURL=auth.js.map